import { Icon } from "@iconify/react";

import Button from "@shared/button";

import style from "./alert.styl";
import store from "./store";

type AlertProps = {
  id: string;
  type?: "success" | "info" | "critical";
  message: string;
};

const Alert = ({ id, type, message }: AlertProps) => {
  const renderIcon = () => {
    switch (type) {
      case "success":
        return (
          <Icon
            icon="feather:check-circle"
            style={{
              width: "1.5rem",
              height: "1.5rem",
              color: "var(--positive-400)",
            }}
          />
        );
      case "info":
        return (
          <Icon
            icon="feather:info"
            style={{
              width: "1.5rem",
              height: "1.5rem",
              color: "var(--primary-400)",
            }}
          />
        );
      case "critical":
        return (
          <Icon
            icon="feather:alert-circle"
            style={{
              width: "1.5rem",
              height: "1.5rem",
              color: "var(--negative-400)",
            }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className={style.alert}>
      {renderIcon()}
      <span className="smallCopy dark">{message}</span>
      <Button
        size="tiny"
        iconButton
        iconColors
        transparent
        onClick={() => store.removeAlert(id)}
      >
        <Icon icon="feather:x" />
      </Button>
    </div>
  );
};

export default Alert;
